import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class FinancialAccountMeta extends BaseEntityModel {
  type?: string;

  parentId?: number;

  constructor(model: Partial<FinancialAccountMeta> = {}) {
    super(model);

    this.type = model.type;
    this.parentId = model.parentId;
  }
}
